enum WheelSearchStep {
  Search = 0,
  Rim = 1,
  Tyre = 2,
}

export default WheelSearchStep